var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billinghistory',{attrs:{"billingHistory":_vm.billingSummary}})
}
var staticRenderFns = []

export { render, staticRenderFns }